module.exports = "<!-- tawks.to comp will load the correct embed script if configured in the env.tawkto_url attribute per language -->"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/tawk-to/tawk-to.component.html
// module id = ../../../../../src/app/components/tawk-to/tawk-to.component.html
// module chunks = main